<template>
    <div
        id="sources"
        class="col-12">
        <div class="box">
            <div class="box-header">
                <h3 class="box-title">Seznam virov</h3>

                <div class="box-tools">
                    <form
                        class="input-group input-group-sm pull-left"
                        style="width: 150px; margin-right: 1rem"
                        @submit.prevent="search">
                        <input
                            v-model="moreParams.name"
                            type="text"
                            name="table_search"
                            class="form-control pull-right"
                            placeholder="Išči">

                        <div class="input-group-btn">
                            <button
                                type="submit"
                                class="btn btn-default">
                                <i class="fa fa-search"/>
                            </button>
                        </div>
                    </form>
                    <button
                        type="button"
                        class="btn btn-success btn-sm pull-left margin-r-5"
                        title="Dodaj nov vir"
                        @click.prevent="showAddModal">
                        <i
                            class="fa fa-plus-circle"
                            aria-hidden="true"/>
                    </button>
                    <button
                        type="button"
                        class="btn btn-default btn-sm pull-left"
                        title="Sinhroniziraj vse"
                        @click.prevent="syncAll">
                        <i
                            class="fa fa-refresh text-green"
                            aria-hidden="true"/>
                    </button>
                </div>
            </div>
            <div
                :class="isLoading ? 'loading' : ''"
                class="box-body table-responsive no-padding">
                <div class="loader">
                    <img
                        src="/images/spinner.svg"
                        alt="Nalagam"
                        width="200"
                        height="200">
                    <b>NALAGAM</b>
                </div>
                <vuetable
                    ref="vuetable"
                    :api-url="api_route"
                    :fields="fields"
                    :css="css.table"
                    :row-class="rowClass"
                    :initial-page="initialPage"
                    :per-page="perPage"
                    :sort-order="sortOrder"
                    :multi-sort="true"
                    :append-params="moreParams"
                    pagination-path="meta"
                    detail-row-component="source-details"
                    @vuetable:loaded="dataLoaded"
                    @vuetable:cell-clicked="onCellClicked"
                    @vuetable:pagination-data="onPaginationData"/>
            </div>
            <div class="box-footer clearfix">
                <div class="vuetable-pagination pagination pagination-sm no-margin pull-left">
                    <p>Zadetkov na stran</p>
                    <select
                        v-model="perPage"
                        @change="changePerPage">
                        <option
                            v-for="option in perPageOptions"
                            :key="option"
                            :value="option">
                            {{ option }} / stran
                        </option>
                    </select>
                </div>
                <div class="vuetable-pagination pagination pagination-sm no-margin pull-right">
                    <vuetable-pagination-info
                        ref="paginationInfo"
                        info-template="Prikazujem {from} do {to} od {total} zapisov"
                        info-class="pagination-info"/>
                    <vuetable-pagination-dropdown
                        ref="pagination"
                        :css="css.dropdownPagination"
                        page-text="stran"
                        @vuetable-pagination:change-page="onChangePage"/>
                </div>
            </div>
        </div>
        <new-source :api_route="api_route"/>
    </div>
</template>

<script>
import Vuetable                   from 'vuetable-2/src/components/Vuetable';
import VuetablePagination         from 'vuetable-2/src/components/VuetablePagination';
import VuetablePaginationDropdown from '../VuetablePaginationDropdownWithFirstAndLast';
import VuetablePaginationInfo     from 'vuetable-2/src/components/VuetablePaginationInfo';
import TablePagination            from '../../mixins/TablePagination';
import SourceDetails              from './SourceDetails';
import SyncAction                 from './SyncAction';
import NewSource                  from './NewSource';
import Table                      from '../../mixins/Table';
import TableUrlParams             from '../../mixins/TableUrlParams';
import ApiRoutes                  from '../../mixins/ApiRoutes';
import sl                         from 'date-fns/locale/sl';
import format                     from 'date-fns/format';
import SourceLabel                from './SourceLabel';
import VuejsDialog                from 'vuejs-dialog';

Vue.component('sync-action', SyncAction);
Vue.component('source-details', SourceDetails);
Vue.component('new-source', NewSource);
Vue.component('source-label', SourceLabel);
Vue.use(VuejsDialog);

export default {
    name: 'Sources',

    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationDropdown,
        VuetablePaginationInfo
    },

    filters: {
        formatDate(value, fmt = 'D MMM YYYY') {
            return value ? format(value, fmt, {locale: sl}) : 'n/a';
        },
    },

    mixins: [
        ApiRoutes,
        Table,
        TableUrlParams,
        TablePagination
    ],

    data() {
        return {
            fields:  [
                {
                    name:       '__checkbox',
                    titleClass: 'center aligned',
                    dataClass:  'center aligned'
                },
                {
                    name:      'id',
                    title:     '#',
                    sortField: 'id',
                },
                {
                    name:      '__component:source-label',
                    title:     'ime / oznaka',
                    sortField: 'name'
                },
                {
                    name:       'section.name',
                    title:      'sekcija',
                    sortField:  'section.name',
                    titleClass: 'text-center',
                    dataClass:  'text-center'
                },
                {
                    name:       'contacts',
                    title:      'št. kontaktov',
                    callback:   value => value.toLocaleString('sl-SI') || 0,
                    sortField:  'contacts',
                    titleClass: 'text-center',
                    dataClass:  'text-center'
                },
            ],
            perPage: 12,

            css: {
                table: {
                    tableClass: 'table table-striped table-hover'
                }
            },

            filterBy: ['name']
        };
    },

    methods: {
        search() {
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },

        syncAll() {
            if (this.$refs.vuetable.selectedTo.filter(el => el !== 1).length) {
                this.$dialog.confirm(
                    `<h4>Ali ste prepričani, da hočete sinhronizirati <b>VSE IZBRANE</b> vire?</h4>
                    <p>Izvajanje zna trajati <b>več ur</b>!!</p>`,
                    {
                        html:       true,
                        okText:     'Da',
                        cancelText: 'Ne',
                    })
                    .then(() => {
                        axios.put('/ajax/sync_all/sources', {
                            source_ids: this.$refs.vuetable.selectedTo.filter(el => el !== 1)
                        })
                            .then(response => {
                                this.$toast.success({
                                    title:   'USPEH!',
                                    message: response.data.status
                                });
                            })
                            .catch(error => {
                                this.$toast.error({
                                    title:   'NAPAKA!',
                                    message: error,
                                    timeOut: 10000
                                });
                            });
                    })
                    .catch(() => {
                        // pfff .... pussy :P
                    });
            } else {
                this.$dialog.confirm(
                    '<h4>Prosim izberite vire, ki naj se sinhronizirajo!</h4>',
                    {
                        html:       true,
                        okText:     'Razumem',
                        cancelText: 'Ne',
                    }
                );
            }
        },

        onChangePage(page) {
            this.$refs.vuetable.changePage(page);

            this.dataLoading();
        }
    },

    events: Object.assign({
        sync(source) {
            axios.get(`${this.api_route}/${source.id}/sync`)
                .then(() => {
                    axios.put(`${this.api_route}/${source.id}/sync`)
                        .then(response => {
                            this.$toast.success({
                                title:   'USPEH!',
                                message: response.data.status
                            });
                        })
                        .catch(error => {
                            this.$toast.error({
                                title:   'NAPAKA!',
                                message: error,
                                timeOut: 10000
                            });
                        });
                })
                .catch(() => {
                    this.$toast.error({
                        title:   'NAPAKA!',
                        message: 'Proces se izvaja oz. je v čakalni vrsti za obdelavo. Prosimo počakajte...',
                        timeOut: 10000
                    });
                });
        }
    }, Table.events)
};
</script>

<style>
    /* VueJS dialog */
    .dg-btn--ok {
        color: #fff;
        background-color: #00a65a;
        border-color: #008d4c;
    }

    .dg-btn--cancel {
        color: #fff;
        background-color: #dd4b39;
        border-color: #d73925;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Sources/Sources.vue